import { memo } from 'react';

const CookieCategory = memo(({ category, isEnabled, onToggle, disabled }) => {
  const toggleId = `toggle-${category.id}`;
  const descriptionId = `description-${category.id}`;

  return (
    <div className="cookie-category">
      <div className="category-header">
        <div className="category-info">
          <span className="category-icon" aria-hidden="true">
            {category.icon}
          </span>
          <div className="category-text">
            <h3 className="category-name">{category.name}</h3>
            {category.required && (
              <span className="required-badge" aria-label="Required">
                Required
              </span>
            )}
          </div>
        </div>

        <div className="category-toggle">
          <div className="form-check form-switch">
            <input
              id={toggleId}
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={isEnabled || category.required}
              onChange={onToggle}
              disabled={category.required || disabled}
              aria-describedby={descriptionId}
              aria-label={`${category.required ? 'Required' : 'Optional'} ${category.name}`}
            />
            <label htmlFor={toggleId} className="form-check-label sr-only">
              Toggle {category.name}
            </label>
          </div>
        </div>
      </div>

      <div className="category-content">
        <p id={descriptionId} className="category-description">
          {category.description}
        </p>

        {category.examples && category.examples.length > 0 && (
          <details className="category-details">
            <summary className="details-summary">View examples</summary>
            <ul className="examples-list">
              {category.examples.map((example, index) => (
                <li key={index} className="example-item">
                  {example}
                </li>
              ))}
            </ul>
          </details>
        )}
      </div>
    </div>
  );
});

CookieCategory.displayName = 'CookieCategory';

export default CookieCategory;
